import { styled } from "@mui/material"
import {
  SecurityDialog,
  SecurityDialogContainer,
  SecurityDialogTitle,
  SecurityLabel,
  SecurityPrimaryButton,
} from "../common"
import { useEmailSentDialog } from "./useEmailSentDialog"

export type EmailSentDialogProps = {
  open: boolean
  goHome: () => void
  closeDialog: () => void
}

export const EmailSentDialog = ({ open, goHome }: EmailSentDialogProps) => {
  const { email } = useEmailSentDialog()

  return (
    <SecurityDialog open={open}>
      <SecurityDialogTitle />
      <SecurityDialogContainer>
        <SecurityLabel>
          Un email vient de vous être envoyé à l’adresse suivante :{" "}
          <Email>{email}</Email>.
        </SecurityLabel>
        <SecurityLabel>
          Pensez à vérifier vos spams si vous ne trouvez pas le message.
        </SecurityLabel>
        <SecurityPrimaryButton onClick={() => goHome()}>
          Retour à l’accueil
        </SecurityPrimaryButton>
      </SecurityDialogContainer>
    </SecurityDialog>
  )
}

const Email = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
}))
